var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useTranslation } from 'react-i18next';
import useSWR from 'swr';
import { useGlobal } from '../context/global/global.context';
import { GlobalActions } from '../context/global/types';
import { menuGeneratorService } from '../services/menu-generator.service';
import { observabilityService } from '../services/observability';
export const useCountriesAllowed = () => {
    const { t } = useTranslation();
    const { state, dispatch } = useGlobal();
    const { auth } = state;
    const swrResponse = useSWR('countries-allowed', () => __awaiter(void 0, void 0, void 0, function* () { return menuGeneratorService.getAllowedCountries(); }), {
        onError: (error, key) => {
            dispatch({
                type: GlobalActions.showNotification,
                payload: { message: t('menuGenerator.table.notification.error'), type: 'error' },
            });
            observabilityService.captureError({
                error,
                name: key,
                user: auth === null || auth === void 0 ? void 0 : auth.userProfile,
            });
        },
    });
    return swrResponse;
};
